import { registerDecorator, ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface } from 'class-validator';
import { BaseValidator } from './commons/base-validator';
import { BaseValidationDecoratorInterface } from './commons/base-validation-decorator.interface';
import { BaseDecoratorInterface } from './commons/base-decorator.interface';
import { BoolMetaData } from '../../meta-data/bool-meta-data';
import { MetaDataUtils } from '../../meta-data/meta-data-utils';
import { RequiredDecoratorInterface } from './commons/required-decorator.interface';

export interface BoolDecoratorInterface extends BaseDecoratorInterface, RequiredDecoratorInterface {
}

@ValidatorConstraint({ name: 'boolValidator', async: false })
export class BoolValidator extends BaseValidator<boolean> implements ValidatorConstraintInterface {

    override validate(value: boolean, args: ValidationArguments): boolean {
        return super.validate(value, args);
    }

    protected static override getPropertyMetaDataFromDecoratorData<TDecoratorData extends BaseValidationDecoratorInterface>(
        decoratorData: TDecoratorData, propertyName: string) {
        const propertyMetaData = new BoolMetaData();
        propertyMetaData.context = decoratorData.context;
        propertyMetaData.isRequired = (decoratorData as BoolDecoratorInterface).isRequired;
        propertyMetaData.descriptions.descriptionKey = (decoratorData as BoolDecoratorInterface).descriptionKey;
        propertyMetaData.descriptions.displayNameKey = (decoratorData as BoolDecoratorInterface).displayNameKey;
        propertyMetaData.name = MetaDataUtils.toPascalCase(propertyName);
        return propertyMetaData;
    }    
}

export function BoolDecorator(decoratorInterface: BoolDecoratorInterface) {
    return (object: object, propertyName: string) => {

        // Metodo di base per tutti i decoratori
        BoolValidator.initBaseValidator(decoratorInterface, object, propertyName);

        // Aggiunge informazioni alla property sulla validazione sul tipo della classe
        BoolValidator.buildPropertyMetaData<BoolDecoratorInterface>(
            object.constructor, propertyName, decoratorInterface);
        // Aggiunge informazioni alla property sulla validazione sull'instanza della classe
        BoolValidator.buildPropertyMetaData<BoolDecoratorInterface>(
            object, propertyName, decoratorInterface);

        registerDecorator({
            target: object.constructor,
            propertyName,
            options: {context: decoratorInterface.context},
            constraints: [decoratorInterface],
            validator: BoolValidator
        });
    };
}
